import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage, extractErrorCode } from '../../../utils/apiResponseHandler';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/trainings/download';

function* process(action) {
  try {
    const { training_id } = action.payload;
    const url = `${config.API_URL}/training/${training_id}/download`;
    const response = yield call(axios.get, url, { headers: getLocalUser() });
    const data = response.data?.data || response.data;
    // Presigned URLs are time-limited, so kick off the browser
    // download right away instead of making the user click twice.
    if (data?.download_url) {
      const a = document.createElement('a');
      a.href = data.download_url;
      a.download = data.filename || 'model';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    yield put(fetchSuccess({ ...data, training_id }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure({
      message: extractErrorMessage(error),
      code: extractErrorCode(error),
    }));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
